/**
 * useActorSwitchReset - run `reset` when the viewer's actor CHANGES, and at
 * no other time (2026-10-22, plan muster).
 *
 * The per-attack toggles (called shot, Charge, All Out, gang-up, the attack
 * mode, a chambered drum action) are this screen's local state, not the
 * combatant's, so one click on the muster carried them to whoever was picked
 * next: a Charge leaked from the Nob to the Gretchin. A switch now starts the
 * new actor clean. What lives ON the combatant (aim, Guarded's stance, the
 * All-Out price) is untouched, and so is the armed weapon and its fire mode,
 * which Spawn's "Act as" sets in the same handler as the actor.
 *
 * Not on mount and not on a re-render as the same actor; a hand-over to or
 * from nobody is a switch. A layout effect, so the cleared pills are what
 * the first frame after the switch paints.
 */
import { useLayoutEffect, useRef } from 'react';

export default function useActorSwitchReset(actorId, reset) {
  const last = useRef(actorId);
  const latestReset = useRef(reset);
  latestReset.current = reset;
  useLayoutEffect(() => {
    if (last.current === actorId) return;
    last.current = actorId;
    latestReset.current();
  }, [actorId]);
}
